"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ApprovalEntryModel () {
        return ApprovalEntryModel;
    },
    get BudgetSummaryModel () {
        return BudgetSummaryModel;
    },
    get CompensationCycleModel () {
        return CompensationCycleModel;
    },
    get EmployeeCompensationModel () {
        return EmployeeCompensationModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _money = require("./money");
const BudgetSummaryModel = _zod.z.object({
    employee_count: _zod.z.number(),
    pending_count: _zod.z.number(),
    in_review_count: _zod.z.number(),
    approved_count: _zod.z.number()
});
const CompensationCycleModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    created_by: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    updated_by: _zod.z.instanceof(_bson.ObjectId),
    updated_at: _zod.z.date(),
    deleted_by: _zod.z.instanceof(_bson.ObjectId).nullable(),
    deleted_at: _zod.z.date().nullable(),
    completed_at: _zod.z.date().nullable(),
    start_date: _zod.z.date(),
    due_date: _zod.z.date(),
    timezone: _zod.z.string(),
    approval_type: _zod.z.enum([
        "chain",
        "manager"
    ]),
    allotment_method: _zod.z.enum([
        "percent_of_payroll",
        "fixed_amount"
    ]),
    allotment_increase: _money.StoredMoney,
    allotment_increase_percent: _zod.z.number(),
    _budget_summary: BudgetSummaryModel,
    _status: _zod.z.enum([
        "active",
        "completed",
        "cancelled"
    ]),
    reopened_at: _zod.z.date().nullable().optional()
});
const ApprovalEntryModel = _zod.z.object({
    approver_id: _zod.z.instanceof(_bson.ObjectId),
    sequence: _zod.z.number(),
    status: _zod.z.enum([
        "pending",
        "approved",
        "submitted"
    ]),
    decided_at: _zod.z.date().nullable(),
    notes: _zod.z.string().nullable(),
    amount_at_approval: _money.StoredMoney.nullable(),
    updated_at: _zod.z.date().optional(),
    proposed_increase_amount: _money.StoredMoney.optional().nullable(),
    proposed_increase_percent: _zod.z.number().optional().nullable(),
    proposed_salary: _money.StoredMoney.optional().nullable()
});
const EmployeeCompensationModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    compensation_cycle: _zod.z.instanceof(_bson.ObjectId),
    employee_id: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    manager_id: _zod.z.instanceof(_bson.ObjectId),
    override_manager_id: _zod.z.instanceof(_bson.ObjectId).nullable(),
    current_salary: _money.StoredMoney,
    current_salary_currency: _zod.z.string().default("USD"),
    // The manager group's share of the cycle budget, snapshotted at creation and
    // repeated on every member's record. Persisted because it cannot be derived
    // later: proposed_increase_amount is overwritten by manager decisions, and
    // re-running the allocation would make its remainder-distribution order a
    // permanent data contract. Absent on cycles created before group budgets
    // were allocated; readers fall back to deriving from the cycle percent.
    group_increase_budget: _money.StoredMoney.nullable().optional(),
    proposed_increase_amount: _money.StoredMoney.nullable(),
    proposed_increase_percent: _zod.z.number().nullable(),
    proposed_salary: _money.StoredMoney.nullable(),
    status: _zod.z.enum([
        "pending",
        "in_review",
        "approved",
        "blocked",
        "submitted"
    ]),
    current_approver_id: _zod.z.instanceof(_bson.ObjectId).nullable(),
    approvals: _zod.z.array(ApprovalEntryModel),
    updated_at: _zod.z.date().optional(),
    my_decision_notes: _zod.z.string().nullable().optional()
});
